import { Status } from '../status/status';
import { Mail } from '../mail/mail';

export class Role {
    id: number;
    description: string;
    mails: Mail[];

    status: Status;
}